import React,{ useEffect } from "react";
import InnerPopup from "./InnerPopup";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { withTranslation } from "react-i18next";
import ReactDOM from "react-dom";
const CancelledBetDeskonPopup = (props) => {
  const { onClose } = props;

  // const callProcessSubmit = () => {
  //     props.submitProcessOk();
  // }
  useEffect(() => {
    const wrapperElement = document.querySelector(".wrapper");

    if (wrapperElement) {
      // Add the 'modal-open' class when the modal is open
      wrapperElement.classList.add("modal-open");
    }

    // Cleanup function to remove the class when the component is unmounted
    return () => {
      if (wrapperElement) {
        wrapperElement.classList.remove("modal-open");
      }
    };
  }, []);

  const wrapperElement = document.querySelector(".homepage");
  return ReactDOM.createPortal(
    <div className="confirmation_modal">
      <InnerPopup onCloseModal={onClose}>
        <div className="betdiskon_poupcontent">
          <div className="confirm_img_conatiner">
            <IoIosInformationCircleOutline />
          </div>
          <p>{props.t("cancel")}</p>
          <div className="bet_txt">{props.t("cancel_message")}</div>

          <div className="confirm_poupcontent_btns">
            <button className="btn" onClick={onClose}>
              OK
            </button>
            {/* <button className="btn" onClick={callProcessSubmit}>
                            Yes
                        </button> */}
          </div>
        </div>
      </InnerPopup>
    </div>,
    wrapperElement
  );
};

export default withTranslation()(CancelledBetDeskonPopup);
